export default class CustomerFiltersModel {
  constructor(obj) {
    obj = obj || {};

    this.startUpdateDate = obj.startUpdateDate;
    this.endUpdateDate = obj.endUpdateDate;
    this.registerStatusList = obj.registerStatusList;
  }
}